import { Tabs } from 'antd';
import type { TabsProps } from 'antd';
import { useTranslation } from 'react-i18next';
import Departments from './departments';
import Projects from './projects';
import XGL from './xgl';

const ClientAccess: React.FC = () => {
  const { t } = useTranslation();

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: t('Departments'),
      children: <Departments />,
    },
    {
      key: '2',
      label: t('Projects'),
      children: <Projects />,
    },
    {
      key: '3',
      label: 'XGL',
      children: <XGL />,
    },
  ];

  return <Tabs type="card" items={items} />;
};

export default ClientAccess;
